import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CkRegisterService } from '../../../ck-register/ck-register.service';
import { AppToastsService } from '../../../shared/app-toasts/app-toasts.service';
import { DataMessageService } from '../../../shared/data-message.service';
import { IReclaims, IReclaimsDet } from '../../../shared/interfaces/reclaims';
import moment from 'moment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-recl-xml-mcs-bitacora-rev032025',
  imports: [
    FormsModule,
    CommonModule,
    NgxMaskDirective
  ],
  templateUrl: './recl-xml-mcs-bitacora-rev032025.component.html',
  styleUrl: './recl-xml-mcs-bitacora-rev032025.component.css'
})
export class ReclXmlMcsBitacoraRev032025Component implements OnInit, OnDestroy {

  @Input() reclaims: IReclaims[];
  @Input() reclaimsDet: IReclaimsDet[];
  @Input() idxSeld: number;
  @Input() reclFormImg64Seled: string;
  @Input() reclLineReasonEntered: IReclaimReason;
  @Input() clrData: boolean = false;  // Set true after deleteing
  @Input() print: boolean = false;

  @Output() need2Save = new EventEmitter<string>();

  sn: string;
  engLang: boolean = false;
  userLastNm: string;
  userFirstNm: string;
  userID: string;
  currIndx: number = -1;

  e: any = {
    plan: '',
    optMCScomercial: false,
    optMCSadvantage: false,
    typ: '',
    optMCSpending: false,
    optMCSadjust: false,

    txtMCSprovNm: '',
    txtMCSprovNPI: '',
    txtMCSprovAddPO1: '',
    txtMCSprovAddPO2: '',
    txtMCSprovAddPOzip: '',
    txtMCSprovAddTel: '',
    txtMCSprovEmail: '',
    txtMCScasNo: '',

    txtMCSpatNm1: '',
    txtMCScontrNo1: '',
    txtMCSfrmDt1: '',
    txtMCStoDt1: '',
    txtMCScpt1: '',
    txtMCSbal1: '',
    txtMCScoment1: '',

    txtMCSpatNm2: '',
    txtMCScontrNo2: '',
    txtMCSfrmDt2: '',
    txtMCStoDt2: '',
    txtMCScpt2: '',
    txtMCSbal2: '',
    txtMCScoment2: '',

    txtMCSpatNm3: '',
    txtMCScontrNo3: '',
    txtMCSfrmDt3: '',
    txtMCStoDt3: '',
    txtMCScpt3: '',
    txtMCSbal3: '',
    txtMCScoment3: '',

    txtMCSpatNm4: '',
    txtMCScontrNo4: '',
    txtMCSfrmDt4: '',
    txtMCStoDt4: '',
    txtMCScpt4: '',
    txtMCSbal4: '',
    txtMCScoment4: '',

    txtMCSpatNm5: '',
    txtMCScontrNo5: '',
    txtMCSfrmDt5: '',
    txtMCStoDt5: '',
    txtMCScpt5: '',
    txtMCSbal5: '',
    txtMCScoment5: '',

    txtMCSpatNm6: '',
    txtMCScontrNo6: '',
    txtMCSfrmDt6: '',
    txtMCStoDt6: '',
    txtMCScpt6: '',
    txtMCSbal6: '',
    txtMCScoment6: '',

    txtMCSpatNm7: '',
    txtMCScontrNo7: '',
    txtMCSfrmDt7: '',
    txtMCStoDt7: '',
    txtMCScpt7: '',
    txtMCSbal7: '',
    txtMCScoment7: '',

    casNo: '',
    footer: ''
  }

  constructor(private _ckRegisterService: CkRegisterService,
    private _appToastsService: AppToastsService,
    private _dataMessageService: DataMessageService
  ) { }

  ngOnInit(): void {
    this._dataMessageService.currentSnStr.subscribe(str => this.userSnChange(str)); // Subscription 
    this._dataMessageService.currentUserLastNmStr.subscribe(str => this.userLastNmChange(str)); // Subscription 
    this._dataMessageService.currentUserFirstNmStr.subscribe(str => this.userFirstNmChange(str)); // Subscription 
    this._dataMessageService.currentUserIdStr.subscribe(str => this.userIdChange(str)); // Subscription 
    this._dataMessageService.currentEngLangStr.subscribe(str => this.engLangChange(str)); // Subscription 

    this.setReclaimDefaults();
    if (this.reclaims[this.idxSeld].reclXml.match(/>\w+</g)) { // If xml has data then read it
      this.decodeXmlRecl();
    }
    this.currIndx = 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.createColReclaimXmlContent_developmentHelperRtn();  // <-- Use to get reclXml col contents value for this form

    // Check if @Input() reclLineReasonEntered & others have changed
    if (changes.reclLineReasonEntered && this.reclLineReasonEntered) {
      console.log('reclLineReasonEntered', this.reclLineReasonEntered);
      if (this.reclLineReasonEntered.reason) {
        // Fill or accumulate .reason in any other extra comment field 
        // not already filled by defaults or in switch(){} block below
      }

      switch (this.currIndx) {
        case -1:
          this.currIndx = 0;
        // break;   In this case the first line is not filled in by default so no break; to go on to case 0
        case 0:
          this.e.txtMCSpatNm1 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo1 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt1 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt1 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt1 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal1 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment1 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        case 1:
          this.e.txtMCSpatNm2 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo2 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt2 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt2 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt2 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal2 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment2 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        case 2:
          this.e.txtMCSpatNm3 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo3 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt3 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt3 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt3 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal3 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment3 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        case 3:
          this.e.txtMCSpatNm4 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo4 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt4 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt4 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt4 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal4 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment4 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        case 4:
          this.e.txtMCSpatNm5 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo5 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt5 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt5 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt5 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal5 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment5 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        case 5:
          this.e.txtMCSpatNm6 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo6 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt6 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt6 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt6 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal6 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment6 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        case 6:
          this.e.txtMCSpatNm7 = this.reclLineReasonEntered.name;
          this.e.txtMCScontrNo7 = this.reclLineReasonEntered.contrNo;
          this.e.txtMCSfrmDt7 = this.reclLineReasonEntered.from;
          this.e.txtMCStoDt7 = this.reclLineReasonEntered.to;
          this.e.txtMCScpt7 = this.reclLineReasonEntered.cpt + ' ' + this.reclLineReasonEntered.mods;
          this.e.txtMCSbal7 = (+this.reclLineReasonEntered.xpected - +this.reclLineReasonEntered.payed).toFixed(2);
          this.e.txtMCScoment7 = this.reclLineReasonEntered.reason.trim();
          this.currIndx++;
          break;
        default:
      }
      this.setTotal();
    }
    if (changes.clrData?.currentValue) {
      this.clearData();
    }
    if (changes.print?.currentValue) {
      this.printReclaim();
    }

  }

  ngOnDestroy(): void {
    this.currIndx = 0;
    this.e = undefined;
  }

  setReclaimDefaults(): void {
    const r: number = this.idxSeld;

    this.e.txtMCSprovNm = this.reclaims[0].reclProv;
    this.e.txtMCSprovNPI = this.reclaims[0].reclNPI;
    this.e.date = moment(new Date()).format('MM/DD/YY');

    this.e.txtMCSprovAddPO1 = this.reclaims[0].reclProvPOaddr1;
    this.e.txtMCSprovAddPO2 = this.reclaims[0].reclProvPOaddr2;
    this.e.txtMCSprovAddPO2 = this.reclaims[0].reclProvPOcity + ' ' + this.reclaims[0].reclProvPOst;
    this.e.txtMCSprovAddPOzip = this.reclaims[0].reclProvPOzip;
    this.e.txtMCSprovAddTel = this.reclaims[0].reclProvTel;

    this.e.txtMCSprovEmail = this.reclaims[0].reclProvEmail;
    this.e.casNo = this.reclaims[0].reclCasNo;
  }

  decodeXmlRecl(): void {
    const r: number = this.idxSeld;

    if (r >= 0 && this.reclaims && (this.reclaims[r].reclXml || this.reclaimsDet[r].reclDetXml)) {
      let parser = new DOMParser();
      let xmlDoc;
      if (this.reclaims[r].reclXml) {
        xmlDoc = parser.parseFromString(this.reclaims[0].reclXml, "text/xml");
      } else if (this.reclaimsDet[r].reclDetXml) {  // UNTESTED
        xmlDoc = parser.parseFromString(this.reclaimsDet[r].reclDetXml, "text/xml");
      } else {
        return;
      }

      for (let i = 0; i < xmlDoc.getElementsByTagName("ReclaimFormFields")[0].childNodes.length; i++) {
        let fullNod = xmlDoc.getElementsByTagName("ReclaimFormFields")[0].childNodes[i];
        let nod = xmlDoc.getElementsByTagName("ReclaimFormFields")[0].childNodes[i].nodeName;

        if (nod.match(/txt\w+/g) || nod.match(/chk\w+/g) || nod.match(/opt\w+/g)) {
          let val = fullNod.textContent;

          switch (nod) {
            case 'optMCScomercial':
              if (+val) {
                this.e.plan = 'comercial';
              }
              break;
            case 'optMCSadvantage':
              if (+val) {
                this.e.plan = 'advantage';
              }
              break;
            case 'optMCSpending':
              if (+val) {
                this.e.typ = 'pending'
              }
              break;
            case 'optMCSadjust':
              if (+val) {
                this.e.typ = 'adjust';
              }
              break;

            default:
              if (nod.match(/txt\w+/g)) {
                this.e[nod] = val.replace(/^%/, '');
              }
          }
        }
      }
    }
  }

  onClick(event): void {
    if (event && event.target.id) {
      const i = event.target.id.match(/\d$/g);
      if (i) {
        this.currIndx = +i[0] - 1;
      }
    }
  }

  onChange_need2Save(event): void {
    this.setTotal()
    this.need2Save.emit('');
  }

  setTotal() {
    // No total this form
  }

  clearData(): void { // Clears all elements with default data.
    Object.keys(this.e).forEach(key => this.e[key] = '');
    this.setReclaimDefaults();
  }

  userLastNmChange(userLastNmStr) {
    this.userLastNm = userLastNmStr;
  }

  userFirstNmChange(userFirstNmStr) {
    this.userFirstNm = userFirstNmStr;
  }

  userIdChange(userIdStr) {
    this.userID = userIdStr;
  }

  userSnChange(snStr) {
    this.sn = snStr;
  }

  engLangChange(engLangStr) {
    this.engLang = engLangStr === 'true';
  }

  printReclaim(): void {
    let data: any = {
      "e": this.e,
    };

    // Set ckboxes , radio buttons and footer
    data.e.optMCScomercial = this.e.plan === 'comercial' ? 'X' : '';
    data.e.optMCSadvantage = this.e.plan === 'advantage' ? 'X' : '';
    data.e.optMCSpending = this.e.typ === 'pending' ? 'X' : '';
    data.e.optMCSadjust = this.e.typ === 'adjust' ? 'X' : '';
    let u = this.userFirstNm + ' ' + this.userLastNm + ' (' + this.userID + ')';
    data.e.footer = (this.engLang ? 'Prepared by ' + u : 'Preparado por ' + u) + '   ' + data.e.date
      + '   ' + (this.engLang ? 'Claim #: ' : 'Caso #: ') + this.e.casNo + '   www.MedicalBiller.us  medbiler@gmail.com   sn:' + this.sn;

    let bdy = {
      "template":
      {
        "name": "/reclaimForms/mcs_bitacora_de_reclamaciones_resometidas_rev-03-20-25/mcs_bitacora_de_reclamaciones_resometidas_rev-03-20-25.html"
      }, "data": data,
      "options": { "reports": { "save": true } }
    };

    this._ckRegisterService.postRenderJsRpt(bdy).subscribe({
      next: blob => { this.renderBlob(blob) },
      error: (error: any) => { this.backFromServerError(error) }
    });
  }

  renderBlob(blob: Blob) {
    const url = window.URL.createObjectURL(blob);
    const newTab = window.open(url);

    if (newTab) {
      newTab.onload = () => {
        window.URL.revokeObjectURL(url);
      };

    } else {
      this._appToastsService.updateDeadCenter(false); // Show toast in dead center of viewport - property sent back to app.component via @ViewChild in app.component
      this._appToastsService.show('Failed to open new tab in browser.', { header: 'Error preparing report * Error preparando reporte', autohide: false, error: true });
    }
  }

  backFromServerError(error): void {
    this._appToastsService.updateDeadCenter(false); // Show toast in dead center of viewport - property sent back to app.component via @ViewChild in app.component
    this._appToastsService.show(error.message, { header: 'Error preparing report * Error preparando reporte', autohide: false, error: true });
  }

  createColReclaimXmlContent_developmentHelperRtn(): void {
    const reclFormDiv = document.getElementById('ReclaimFormFields');
    if (reclFormDiv) {
      let reclXml: string = '<ReclaimFormFields>';  // This id="ReclaimFormFields" must be set temporarily in top <div> for this to work
      const txts = reclFormDiv.querySelectorAll('input');
      txts.forEach(e => {
        reclXml += '<' + e.id + '></' + e.id + '>';
      });
      reclXml += '</ReclaimFormFields>';
      console.log('*** reclXml ***');
      console.log(reclXml);
    }
  }

}
